import { Alert, Button, TCounsellorProfileProps } from '@unmind/design-system';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'Shared/Modal';

import {
  Container,
  CounsellorProfile,
  CTAList,
} from './CounsellorModal.styles';

export type ModalContentProps = {
  data?: TCounsellorProfileProps[];
  isOpen: number | string | false;
  functions: {
    onClose(): void;
    onSelect(counsellor: string | number): void;
  };
};

const ModalContent = ({ data, isOpen, functions }: ModalContentProps) => {
  const { t } = useTranslation('book', {
    keyPrefix: 'service.form.counsellor.modal',
  });

  const counsellor = data?.find(c => c.id === isOpen.toString());
  if (!counsellor || !counsellor.id) {
    return isOpen ? (
      <Alert variant="error" size="small" title={t('error')} />
    ) : (
      <></>
    );
  }

  return (
    <Container>
      <CounsellorProfile
        title={counsellor.title}
        times={counsellor.times}
        picture={counsellor.picture}
      />
      <p dangerouslySetInnerHTML={{ __html: counsellor.content || '' }} />

      <CTAList>
        <li>
          <Button label={t('close')} onClick={functions.onClose} />
        </li>
        <li>
          <Button
            variant="primary"
            label={t('select')}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              functions.onSelect(counsellor.id as string); // always string but ts hasn't inferred
              functions.onClose();
            }}
          />
        </li>
      </CTAList>
    </Container>
  );
};

export const CounsellorModal = ({
  parentRef,
  testId = 'counsellor-modal',
  ...props
}: ModalContentProps & {
  parentRef: RefObject<HTMLElement>;
  testId?: string;
}) => (
  <Modal
    testId={testId}
    open={props.isOpen !== false}
    onCloseCallback={props.functions.onClose}
    closeHeader
    modalContent={({ close }) => (
      <ModalContent
        {...props}
        functions={{
          ...props.functions,
          onClose: () => {
            close();
            props.functions.onClose();
          },
        }}
      />
    )}
    size="medium"
    returnFocusTo={parentRef}
  />
);
